
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SignupForm from '@/components/auth/SignupForm';
import SignupSuccessMessage from '@/components/auth/SignupSuccessMessage';
import ErrorDisplay from '@/components/auth/ErrorDisplay';
import { BASIC_EDUCATION_OPTIONS } from '@/data/educationOptions';
import { useSignupForm } from '@/hooks/useSignupForm';

const Signup = () => {
  const {
    name,
    setName,
    email,
    setEmail,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    age,
    setAge,
    phone,
    setPhone,
    educationStatus,
    setEducationStatus,
    isLoading,
    authLoading,
    errors,
    formError,
    isChecking,
    isAuthenticated,
    showSuccessMessage,
    handleSignup,
  } = useSignupForm();
  
  if (isChecking && !isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow flex items-center justify-center p-4 sm:p-6 md:p-8">
        {showSuccessMessage ? (
          <SignupSuccessMessage />
        ) : (
          <div className="max-w-md w-full bg-white rounded-2xl shadow-soft p-8 animate-fade-in">
            <div className="text-center mb-8">
              <h1 className="text-2xl font-bold text-brand-blue mb-2">Create Your Account</h1>
              <p className="text-gray-600">Join to unlock your career potential</p>
            </div>
            
            <ErrorDisplay error={formError} />
            
            <SignupForm 
              name={name}
              setName={setName}
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              confirmPassword={confirmPassword}
              setConfirmPassword={setConfirmPassword}
              age={age}
              setAge={setAge}
              phone={phone}
              setPhone={setPhone}
              educationStatus={educationStatus}
              setEducationStatus={setEducationStatus}
              educationOptions={BASIC_EDUCATION_OPTIONS}
              errors={errors}
              isLoading={isLoading || authLoading}
              onSubmit={handleSignup}
            />
            
            <div className="mt-8 text-center">
              <p className="text-gray-600 text-sm">
                Already have an account?{' '}
                <Link to="/login" className="text-brand-lightBlue hover:underline font-medium">
                  Log in
                </Link>
              </p>
            </div>
          </div>
        )}
      </main>
      
      <Footer />
    </div>
  );
};

export default Signup;
